import React, {
  useRef,
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import SearchPanel from "../../../../../widgets/SearchPanel";
import { getInitFormData } from "@shared/utils/CommonUtils";
import { global, globalMenu } from "@shared/libs/Global"; // Login User관련 전역 변수( 로그인 정보)
import { ColumnConfig } from "@shared/components/Grid/types";
import SnAgGrid from "@shared/components/Grid/SnGrid";
import { menuInfo } from "@shared/type/CommonType";
import { callApi, fnGetDataSet, fnSave } from "@shared/api/restApi";
import { showDialog } from "@widgets/CommonDialog";

interface Props {
  Menuprops: menuInfo;
}

const EXC000000000029009 = forwardRef(({ Menuprops }: Props, ref) => {
  const gridRef = useRef<any>(null);
  const searchRef = useRef<any>(null);
  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [gridFocus, setGridFocus] = useState(false);

  const [columns, setColums] = useState<ColumnConfig[]>([]);
  const [dataSource1, setDataSource1] = useState<any[]>([]); // 초기값을 빈 배열로 설정
  const { userInfo } = global(); // Login user 정보
  const today = new Date();
  const todayform = `${today.getFullYear()}${(today.getMonth() + 1)
    .toString()
    .padStart(2, "0")}${today.getDate().toString().padStart(2, "0")}`;

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData();
        setFormData(rtn.formData);
        setFormControlData(rtn.formControlData);
        setColums(rtn.grid.grid1);
      } catch (error) {}
    };
    fetchform();
  }, []);

  useEffect(() => {
    gridRef.current.selectAndFocusRow(0);
    setGridFocus(false);
  }, [gridFocus]);

  useImperativeHandle(ref, () => ({
    onSearch,
  }));

  const onSearch = async () => {
    try {
      const p = {
        ...searchRef.current.getFormdata(),
        g_cd_firm: userInfo.cd_firm,
        g_cd_cust: userInfo.cd_cust || "",
      };

      const params = {
        id: "exc000000000029009_01",
        params: p,
      };
      setDataSource1([]);
      const data: any = await fnGetDataSet(params);
      setDataSource1(data[0]);
      await new Promise((resolve) => setTimeout(resolve, 50));
      setGridFocus(true);
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };

  return (
    <div className="h-full flex flex-col">
      <div>
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
          
        ></SearchPanel>
      </div>
      <div className="flex justify-end p-2 space-x-2"></div>
      <div className="flex-1">
        <SnAgGrid
          ref={gridRef}
          
          enableAddRow={true}
          columnConfig={columns} // 컬럼 설정 전달
          rowData={dataSource1}
          enableExternalChart={false}
          //chartColumns={["qt", "am"]}
          isEditable={true}
          rowSelection="multiple" // 단일 선택 모드
          ischeckboxSelection={true} // 체크박스 유무
        />
      </div>
    </div>
  );
});

export default EXC000000000029009;
